export const mensajesInbox = {
  title: "Mensajes",

  noAccess: {
    description:
      "Para acceder a la bandeja de mensajes debes tener conectado tu propio número de WhatsApp Business desde la configuración de cuenta.",
    connectButton: "Conectar WhatsApp",
  },

  search: {
    placeholder: "Buscar por teléfono o huésped...",
  },

  filters: {
    allProperties: "Todas las propiedades",
    searchProperty: "Buscar propiedad...",
    filterTitle: "Filtrar mensajes",
    clearAll: "Quitar filtros",
    removeOne: "Quitar «{filtro}»",
    someActive: "{count} filtros",
  },

  tabs: {
    all: "Todos",
    unread: "No leídos",
    pinned: "Anclados",
    archived: "Archivados",
    noReservation: "Sin reserva",
    otaBooking: "Booking.com",
    otaAirbnb: "Airbnb",
    otaExpedia: "Expedia",
    otaOther: "Otra OTA",
    unpaid: "Sin pagar",
    paid: "Pagadas",
    arrivingSoon: "Entran pronto",
  },

  filterGroups: {
    chat: "Conversación",
    origin: "Origen",
    reservation: "Reserva",
  },

  list: {
    empty: "No hay conversaciones",
    noMessages: "Sin mensajes",
  },

  channels: {
    web: "Web",
    webConcierge: "Conserje web · Portal de estancia",
    otaMessage: "Mensaje {provider}",
  },

  chat: {
    placeholderSelect: "Selecciona una conversación para comenzar",
    loading: "Cargando conversación...",
    dropToAttach: "Suelta aquí para adjuntar archivos",
    emptyThread: "No hay mensajes aún en este hilo",
    notSent: "No se envió",
    sending: "Enviando...",
  },

  sender: {
    guest: "Huésped",
    you: "Tú",
    aiAgent: "Agente IA",
  },

  media: {
    document: "Documento",
    sharedLocation: "Ubicación compartida",
    attachment: "Adjunto",
  },

  preview: {
    attachmentSent: "Adjunto enviado",
    messageSent: "Mensaje enviado",
    attachmentReceived: "Adjunto recibido",
    newMessage: "Nuevo mensaje",
  },

  mode: {
    aiAgent: "Agente IA",
    manual: "Manual",
  },

  automation: {
    disabledNotice:
      "El Agente IA no está activo en esta propiedad: no responderá, los mensajes los escribes tú.",
    aiActiveBanner:
      "El agente IA está respondiendo automáticamente a este huésped.",
  },

  faq: {
    title: "Preguntas frecuentes",
  },

  composer: {
    placeholder: "Escribe un mensaje o usa / para insertar una respuesta...",
    hint: "Enter para enviar · Shift+Enter para nueva línea",
  },

  actions: {
    newConversation: "Nueva conversación",
    options: "Opciones",
    attachFile: "Adjuntar archivo",
  },

  alt: {
    flag: "Bandera",
    sentImage: "Imagen enviada",
  },

  common: {
    file: "archivo",
    notAvailable: "No disponible",
  },

  nights: "{count} noche | {count} noches",

  arrival: {
    pending: "Fecha pendiente",
    today: "Entra hoy",
    tomorrow: "Entra mañana",
    yesterday: "Entró ayer",
    inDays: "Faltan {count} días",
    daysAgo: "Entró hace {count} días",
  },

  reservationStatus: {
    booked: "Confirmada",
    cancelled: "Cancelada",
    pending: "Pendiente",
    checked_in: "En casa",
    checked_out: "Checkout",
  },

  reservationPanel: {
    title: "Reserva asociada",
    stayEnded: "El huésped ya no está hospedado",
    checkIn: "Entrada",
    checkOut: "Salida",
    room: "Habitación",
    reservation: "Reserva",
    phone: "Teléfono",
    viewReservation: "Ver reserva",
    noReservationTitle: "Sin reserva vinculada",
    noReservationOta:
      "Este hilo llegó desde {channel} por Channex y todavía no está relacionado con una reserva local.",
    noReservationWhatsapp:
      "Este contacto escribió al WhatsApp conectado, pero todavía no está relacionado con una reserva.",
    assignReservation: "Asignar reserva",
    createReservation: "Crear reserva",
    assignExisting: "Asignar reserva existente",
    searchPlaceholder: "Buscar por nombre o código...",
    noReservationsFound: "No hay reservas encontradas",
    placeholderContext: "Selecciona una conversación para ver el contexto",
    propertyUnavailable: "Propiedad no disponible",
  },

  contextMenu: {
    pin: "Anclar conversación",
    unpin: "Desanclar conversación",
    archive: "Archivar conversación",
    unarchive: "Desarchivar conversación",
  },

  waStatus: {
    read: "Leído",
    delivered: "Entregado",
    queued: "En cola",
    failed: "Falló",
    sent: "Enviado",
  },

  waFailTitle: {
    noWhatsapp: "Sin WhatsApp",
    invalidNumber: "Número inválido",
    notSent: "No enviado",
  },

  waErrors: {
    generic: "No se pudo enviar este mensaje por WhatsApp.",
  },

  waErrorShort: {
    e131042: "problema de pago en la cuenta de WhatsApp",
    e131026: "el número no puede recibir WhatsApp",
    e131053: "WhatsApp no pudo descargar el archivo",
    e132000: "faltan datos en la plantilla",
    e131009: "el mensaje no cumple los requisitos de WhatsApp",
  },

  toasts: {
    aiActiveSwitchManual:
      "El agente IA está activo. Cambia a modo manual para responder.",
    pinned: "Conversación anclada",
    unpinned: "Conversación desanclada",
    archived: "Conversación archivada",
    unarchived: "Conversación desarchivada",
    reservationAssigned: "Reserva asignada: {name}",
    reservationUnassigned: "Reserva desasignada",
    selectPropertyToCreate:
      "Selecciona una propiedad para crear la reserva desde este chat.",
    userNotResolved: "No fue posible resolver el usuario del panel.",
    aiNotEnabledConfig:
      "Esta propiedad no tiene el Agente IA activo. Actívalo desde la configuración del listing.",
    aiEnabledForChat: "Agente IA activado para esta conversación",
    manualEnabledForChat: "Modo manual activado para esta conversación",
    templateSent: "Plantilla enviada correctamente.",
  },

  errors: {
    inboxNotActive:
      "La bandeja de mensajes no esta activa para esta cuenta o falta conectar el WhatsApp de empresa.",
    openConversation: "No se pudo abrir la conversación",
    sendMessage: "No se pudo enviar el mensaje. Verifica tu conexión WhatsApp.",
    pin: "Error al anclar conversación",
    archive: "Error al archivar",
    loadReservations: "Error cargando reservas",
    assignReservation: "Error al asignar la reserva",
    unassignReservation: "Error al desasignar la reserva",
    updateMode: "No se pudo actualizar el modo de esta conversación",
    reactivationTemplate: "No se pudo enviar la plantilla de reactivación.",
  },
};
